// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/maintenance-release-signing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/maintenance-release-signing/maintenance-release-and-elementary-work.js';
import g1 from '../lessons/air-law/maintenance-release-signing/maintenance-release-signing.js';

mount([g0, g1]);
